import React from "react";
import { REACT_APP_GERS_API_URL } from "shared/config";

interface OptionTemplateImageProps {
  imageId: string;
  className?: string;
  alt?: string;
}

const OptionConfigurationImage: React.FC<OptionTemplateImageProps> = ({
  imageId,
  className = "",
  alt = "",
}) => {
  const path = `${REACT_APP_GERS_API_URL}/OptionTemplateContainers/download?fileId=${imageId}`;
  if (!imageId) {
    return <></>;
  }

  return <img src={path} className={className} alt={alt} />;
};

export default OptionConfigurationImage;
